export default __webpack_public_path__ + "static/media/information--traffic-merges-right--g1.53636e9b.png";